<button
  type="button"
  class="theme-toggle-btn"
  [attr.aria-label]="
    isDark ? ('profile.lightMode' | translate) : ('profile.darkMode' | translate)
  "
  [attr.title]="
    isDark ? ('profile.lightMode' | translate) : ('profile.darkMode' | translate)
  "
  (click)="toggleTheme()">
  @if (isDark) {
    <shared-feather-icons [icon]="'sun'"></shared-feather-icons>
  } @else {
    <shared-feather-icons [icon]="'moon'"></shared-feather-icons>
  }
</button>
